<template>
  <div class="main-container flex flex-center">
    <div class="main-box">
      <!--头部导航-->
      <div class="box-header flex flex-center">
        <div class="box-header-left flex flex-center">
          <div class="title-bc">系统设置</div>
        </div>
      </div>
      <!--内容-->
      <div class="box-content">
        <div class="box-setting">
            <div class="flex input-wrap has-title" style="width:100%;">
              <span class="cus-input-title">重量</span>
              <el-select v-model="bean" placeholder="">
                <el-option
                    v-for="item in been_options"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                </el-option>
              </el-select>
            </div>
            <div class="flex input-wrap has-title" style="width:100%;">
              <span class="cus-input-title">单位</span>
              <el-select v-model="bean" placeholder="">
                <el-option
                    v-for="item in been_options"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                </el-option>
              </el-select>
            </div>
            <el-button type="warning" style="float:right;padding:10px 20px;">保存</el-button>
        </div>
        <div class="box-setting">
          <div class="flex input-wrap " style="width:100%;">
            <el-input type="textarea" :rows="4"></el-input>
          </div>
          <el-button type="warning" style="float:right;padding:10px 20px;">保存</el-button>
        </div>
      </div>
    </div>

  </div>
</template>

<script>

export default {
  name: 'systemSetting',
  data() {
    return {
      bean:'kg',
      been_options: [{
        value: 'kg',
        label: 'kg'
      }, {
        value: 't',
        label: 't'
      }, {
        value: 'm',
        label: 'm'
      }, {
        value: 'mg',
        label: 'mg'
      }],
    }
  },
  methods: {}
}
</script>

